import React from 'react';
import { Camera, Image as ImageIcon } from 'lucide-react';
export function MediaGallery() {
  return <div className="p-4 space-y-4" data-id="element-72">
      <div className="flex items-center justify-between" data-id="element-73">
        <h2 className="text-xl font-semibold text-gray-900" data-id="element-74">Galerie média</h2>
        <button className="bg-red-600 text-white p-2 rounded-lg hover:bg-red-700 transition-colors" data-id="element-75">
          <Camera size={20} data-id="element-76" />
        </button>
      </div>
      <div className="flex flex-col items-center justify-center h-64 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300" data-id="element-77">
        <ImageIcon size={48} className="text-gray-400 mb-4" data-id="element-78" />
        <p className="text-gray-600 text-center" data-id="element-79">Aucune photo pour le moment</p>
        <p className="text-sm text-gray-500 text-center mt-2" data-id="element-80">
          Appuyez sur le bouton caméra pour ajouter des photos
        </p>
      </div>
    </div>;
}